// extracted by mini-css-extract-plugin
module.exports = {"mbs3":"Form_mbs3_1ja32"};